import React, { useContext } from 'react';

import { useParams } from 'react-router';

import { DiscoveryModeCampaignContainer } from '../../overview'; 
import { useSearchParams } from 'react-router-dom';
import { DiscoveryModeContext } from '@/contexts/DiscoveryModeContext';

export function DiscoveryModeCampaignPage() {
  const { campaignId, nodeType, nodeId } = useParams()
  const {
    start,
    end,
    selectedOrganizations,
    selectedLabels,
    selectedArtists,
    breakdown,
    stage
  } = useContext(DiscoveryModeContext)
  let params = {}
  params[nodeType + 'Id'] = nodeId

  const [searchParams] = useSearchParams()

  return ( 
    <DiscoveryModeCampaignContainer
      campaignId={campaignId}
      start={start}
      end={end}
      stage={stage ?? 'END'}
      selectedOrganizations={selectedOrganizations}
      selectedLabels={selectedLabels}
      selectedArtists={selectedArtists}
      breakdown={breakdown}
    /> 
  )
} 
 